import { createSlice } from "@reduxjs/toolkit";

export const monitorPageSlice = createSlice({
    name: 'monitor',
    initialState: {
        value: {
            eocactive: true,
            eocqualify: true,
            eocunactive: true
        },
        page: 'map',
        timelineweek: []
    },
    reducers: {
        setMonitorPage: (state, action) => {
            state.page = action.payload;
        },
        setMonitorShowSelected: (state, action) => {
            state.value = action.payload;
        },
        setMonitorTimelineWeek: (state, action) => {
            state.timelineweek = action.payload;
        }
    }
})

export const { setMonitorPage, setMonitorShowSelected, setMonitorTimelineWeek } = monitorPageSlice.actions;

export const getMonitorPage = (state) => state.monitorpage.page;
export const getMonitorShowSelected = (state) => state.monitorpage.value;
export const getMonitorTimelineWeek = (state) => state.monitorpage.timelineweek;

export default monitorPageSlice.reducer;